import { type FC } from 'react';
import { MapFeature } from '~/_shared/types/toolsAndFeatures/mapFeatures.types';
import { useIsDataExportAllowed } from '~/_shared/types/toolsAndFeatures/useIsDataExportAllowed';
import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { useLassoToolModal } from '~/map/map/lassoTool/useLassoToolModal';
import { type AppState } from '~/store/app.store';
import { useIsMobileScreenSelector } from '~/store/frontendState/deviceInfo/deviceInfo.selector';
import { useIsConnectedLayeredMapSelector } from '~/store/mapInfo/mapInfo.selectors';
import { usePublicMapSettingsSelector } from '~/store/mapSettings/publicMapSettings/mapSettingsPublicMapSettings.selectors';
import {
  useIsMapEditDisabled, useIsMapPresentationalSelector,
} from '~/store/selectors/useMapInfoSelectors';
import { RightSideMapToolsComponent } from './rightSideMapTools.component';

const streetViewSelector = (state: AppState) => state.frontendState.mapTools.streetView;

export const RightSideMapToolsContainer: FC = () => {
  const publicMapSettings = usePublicMapSettingsSelector();
  const streetView = useSelector(streetViewSelector);
  const isMapPresentational = useIsMapPresentationalSelector();
  const isLayeredMapConnected = useIsConnectedLayeredMapSelector();
  const isMobileScreen = useIsMobileScreenSelector();
  const isEditModeDisabled = useIsMapEditDisabled();
  const hideLassoDueNoActions = !useLassoToolModal().allowedLassoActions.length;
  const isDataExportAllowed = useIsDataExportAllowed(MapFeature.ExportData);

  return (
    <RightSideMapToolsComponent
      isExportDataEnabled={isDataExportAllowed}
      forceHideLasso={hideLassoDueNoActions}
      isEditModeDisabled={isEditModeDisabled}
      isMapPresentational={isMapPresentational}
      isLayeredMapConnected={isLayeredMapConnected}
      isMobileScreen={isMobileScreen}
      publicMapSettings={publicMapSettings}
      streetView={streetView}
    />
  );
};
